import React from "react";
import { Box, Typography, Button, Container, Card, Stack } from "@mui/material";

import hero from "../assets/bar.jpeg";
import cafe from "../assets/brioches.jpeg";
import roast from "../assets/roast.jpg";
import grind from "../assets/moka.jpg";
import brew from "../assets/cofee.jpg";
import food1 from "../assets/anguriaDrink.jpeg";
import food2 from "../assets/matcha.jpg";
import food3 from "../assets/milkcofee.jpg";
import srilanka from "../assets/srilanka.png";
import { useNavigate } from "react-router-dom";

const brown = "#6b4f3b";

export default function HomePage() {
  const navigate = useNavigate();
  return (
    <>
      {/* ================= HERO ================= */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url(${hero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
        }}
      >
        <Box
          sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0,0,0,0.55)" }}
        />

        <Container sx={{ position: "relative", textAlign: "center" }}>
          <Typography
            fontSize={{ xs: 36, md: 56 }}
            fontWeight="bold"
            sx={{ textShadow: "0 4px 12px rgba(0,0,0,0.6)" }}
          >
            Caffè perfetto
            <br />
            Atmosfera unica.
          </Typography>

          <Typography
            sx={{ mt: 3, mb: 5, opacity: 0.9, fontSize: { xs: 16, md: 18 } }}
          >
            Alcuni momenti non hanno bisogno di molto.
            <br />
            Solo un buon caffè e qualcuno con cui condividerlo.
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate("/crush-coffee")}
            sx={{
              bgcolor: brown,
              borderRadius: 10,
              px: 6,
              py: 1.5,
              fontSize: 16,
              fontWeight: "bold",
              "&:hover": { bgcolor: "#4e3728", transform: "scale(1.05)" },
              transition: "all 0.3s ease",
            }}
          >
            Scopri il Menu
          </Button>
        </Container>
      </Box>

      {/* ================= ABOUT ================= */}
      <Container sx={{ py: 14 }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={8}
          alignItems="center"
        >
          <Box flex={1}>
            <Typography variant="h4" fontWeight="bold" mb={3}>
              Crush Café è il luogo dove buon caffè e buone vibrazioni si
              incontrano.
            </Typography>

            <Typography sx={{ color: "text.secondary", mb: 4 }}>
              Che tu stia chiacchierando con amici, leggendo un libro o
              semplicemente passando di qui, questo è il tuo spazio per
              rilassarti e sentirti a casa.
            </Typography>

            <Button
              variant="contained"
              onClick={() => navigate("/crush-coffee")}
              sx={{
                bgcolor: brown,
                borderRadius: 10,
                px: 5,
                py: 1.5,
                fontWeight: "bold",
                "&:hover": { bgcolor: "#4e3728", transform: "scale(1.05)" },
                transition: "all 0.3s ease",
              }}
            >
              Ordina ora
            </Button>
          </Box>

          <Box flex={1}>
            <Box
              component="img"
              src={cafe}
              sx={{
                width: "100%",
                borderRadius: 5,
                boxShadow: "0 16px 40px rgba(0,0,0,0.2)",
              }}
            />
          </Box>
        </Stack>
      </Container>

      {/* ================= PROCESS ================= */}
      <Box sx={{ py: 12, bgcolor: "#fffaf5" }}>
        <Container>
          <Typography variant="h4" textAlign="center" fontWeight="bold" mb={8}>
            Il Nostro Processo
          </Typography>

          <Stack direction={{ xs: "column", md: "row" }} spacing={4}>
            {[
              {
                title: "Tostatura",
                desc: "Chicchi tostati lentamente per esaltare aromi e profumi naturali.",
                img: roast,
              },
              {
                title: "Macinatura",
                desc: "Consistenza perfetta per un gusto equilibrato e intenso.",
                img: grind,
              },
              {
                title: "Estrazione",
                desc: "Tecnica esperta per un caffè morbido, ricco e avvolgente.",
                img: brew,
              },
            ].map((item, i) => (
              <Card
                key={i}
                sx={{
                  flex: 1,
                  height: 420,
                  borderRadius: 5,
                  backgroundImage: `url(${item.img})`,
                  backgroundSize: "cover",
                  position: "relative",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "flex-end",
                  p: 8,
                  color: "white",
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: "0 20px 50px rgba(0,0,0,0.3)",
                  },
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    bgcolor: "rgba(0,0,0,0.45)",
                  }}
                />

                <Box sx={{ position: "relative" }}>
                  <Typography variant="h5" fontWeight="bold">
                    {item.title}
                  </Typography>
                  <Typography fontSize={14}>{item.desc}</Typography>
                </Box>
              </Card>
            ))}
          </Stack>
        </Container>
      </Box>

      {/* ================= MENU HIGHLIGHTS ================= */}
      <Container sx={{ py: 14 }}>
        <Typography variant="h4" textAlign="center" fontWeight="bold" mb={8}>
          Le Nostre Specialità
        </Typography>

        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={4}
          justifyContent="center"
          alignItems={{ xs: "center", md: "flex-start" }}
        >
          <Box sx={{ width: { xs: "100%", md: 450 }, flexShrink: 0 }}>
            <Box
              component="img"
              src={food1}
              sx={{
                width: "100%",
                borderRadius: 4,
                boxShadow: "0 12px 36px rgba(0,0,0,0.2)",
                transition: "transform 0.3s ease",
                "&:hover": { transform: "scale(1.03)" },
              }}
            />
          </Box>

          <Stack
            spacing={3}
            sx={{ width: { xs: "100%", md: 450 }, flexShrink: 0 }}
          >
            <Box
              component="img"
              src={food2}
              sx={{
                width: "100%",
                borderRadius: 4,
                boxShadow: "0 12px 36px rgba(0,0,0,0.2)",
                transition: "transform 0.3s ease",
                "&:hover": { transform: "scale(1.03)" },
              }}
            />
            <Box
              component="img"
              src={food3}
              sx={{
                width: "100%",
                borderRadius: 4,
                boxShadow: "0 12px 36px rgba(0,0,0,0.2)",
                transition: "transform 0.3s ease",
                "&:hover": { transform: "scale(1.03)" },
              }}
            />
          </Stack>
        </Stack>

        <Box textAlign="center" mt={6}>
          <Button
            variant="contained"
            onClick={() => navigate("/About")}
            sx={{
              bgcolor: brown,
              borderRadius: 10,
              px: 5,
              py: 1.5,
              fontWeight: "bold",
              "&:hover": { bgcolor: "#4e3728", transform: "scale(1.05)" },
            }}
          >
            Chi Siamo
          </Button>
        </Box>
      </Container>

      {/* ================= SRI LANKA SECTION ================= */}
      <Box
        sx={{
          position: "relative",
          py: { xs: 10, md: 14 },
          color: "white",
          backgroundImage: `url(${srilanka})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.55) 40%, rgba(0,0,0,0.15) 100%)",
          }}
        />

        <Container
          maxWidth={false}
          sx={{
            width: "80%",
            mx: "auto",
            position: "relative",
            zIndex: 2,
          }}
        >
          <Stack spacing={4} maxWidth={520}>
            <Typography variant="h3" fontWeight="bold">
              Scopri luoghi nascosti nello Sri Lanka
            </Typography>

            <Typography sx={{ opacity: 0.9, fontSize: 17 }}>
              Dai viaggi in treno tra piantagioni di tè avvolte nella nebbia
              alle albe panoramiche segrete, creiamo esperienze autentiche e
              personalizzate per coppie, famiglie e piccoli gruppi.
            </Typography>

            <Button
              variant="contained"
              onClick={() => navigate("/tours")}
              sx={{
                bgcolor: brown,
                width: "fit-content",
                px: 5,
                py: 1.5,
                borderRadius: 10,
                fontWeight: "bold",
              }}
            >
              Esplora i Tour
            </Button>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
